import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={centered ? 'text-center' : 'text-left'} data-id="element-63" data-mp="3f36q7i3iln6m">
      <h2 className={`font-display max-w-4xl text-4xl font-extrabold uppercase leading-[1.05] text-zinc-50 md:text-6xl ${centered ? 'mx-auto' : ''}`} data-id="element-64" data-mp="3k185rt1qf4dc">{title}</h2>
      <div className={`mt-6 h-1 w-16 bg-amber-400 ${centered ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-65" data-mp="gjgigryjj8lh" />
      {subtitle && <p className={`mt-6 max-w-3xl text-lg leading-relaxed text-zinc-400 md:text-xl ${centered ? 'mx-auto' : ''}`} data-id="element-66" data-mp="1v3og0j0jztm">{subtitle}</p>}
    </div>;
}